import { useEffect, useState } from "react";
import { invoke } from "@tauri-apps/api/core";
import { getTigerResource } from "../../utils/tigerResource";
import { acrylicStyles, acrylicTokens } from "../../theme/acrylic";

// Fatal startup license-error modal — port of the C++ Ui_show_license_error +
// exit(1). Self-driven: queries get_license_status on mount; if the license is
// invalid it overlays a non-dismissable acrylic dialog whose only action quits
// the app (exit_license_failure). Renders nothing when the license is valid.
const styles = {
  ...acrylicStyles,
  overlay: {
    ...acrylicStyles.overlay,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dialog: {
    background: acrylicTokens.surface,
    backdropFilter: acrylicTokens.surfaceBlur,
    WebkitBackdropFilter: acrylicTokens.surfaceBlur,
    border: acrylicTokens.surfaceBorder,
    borderRadius: acrylicTokens.surfaceRadius,
    width: 440,
    maxWidth: "92vw",
    boxShadow: acrylicTokens.surfaceShadow,
    overflow: "hidden" as const,
  },
  body: {
    padding: "20px 24px",
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  icon: {
    fontSize: 28,
    color: "#ef4444",
    lineHeight: 1,
    flexShrink: 0,
  },
  message: {
    fontSize: 14,
    color: "#4b5260",
  },
} as const;

export function LicenseErrorDialog() {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    invoke<string | null>("get_license_status")
      .then((m) => setMessage(m ?? null))
      .catch(() => setMessage(null));
  }, []);

  if (!message) return null;

  const onExit = () => {
    void invoke("exit_license_failure");
  };

  return (
    <div style={styles.overlay}>
      <div
        style={styles.dialog}
        role="alertdialog"
        aria-modal="true"
        aria-label={getTigerResource("TIGER_LICENSE_ERROR_TITLE")}
      >
        <div style={styles.header}>
          <span style={styles.title}>{getTigerResource("TIGER_LICENSE_ERROR_TITLE")}</span>
        </div>
        <div style={styles.body}>
          <span style={styles.icon} aria-label={getTigerResource("TIGER_ERROR")}>&#9888;</span>
          <span style={styles.message}>{message}</span>
        </div>
        <div style={styles.footer}>
          <button className="btn-acrylic-primary" onClick={onExit} autoFocus>
            {getTigerResource("TIGER_LICENSE_EXIT")}
          </button>
        </div>
      </div>
    </div>
  );
}
